<template>
    <div id="wrapper">
      <Sidebar></Sidebar>
      <!-- Content Wrapper -->
      <div id="content-wrapper" class="d-flex flex-column">

        <!-- Main Content -->
        <div id="content">

          <Topbar></Topbar>

          <!-- Begin Page Content -->
          <div class="container-fluid">

            <!-- Page Heading -->
            <router-link :to="{ name: 'Home'}" > CRCB Control Panel</router-link> >
            <router-link :to="{ name: 'News'}" > 內容管理</router-link> >
            <span>內容管理{{mode}}</span>
            <h1 class="h3 mb-2 mt-2 text-gray-800">內容管理{{mode}}</h1>
            <Msg :message="message" :is_error="is_error"></Msg>

            <div class="text-center" v-if="loading" >
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>  
            <!-- DataTales -->
            <div class="card shadow mb-4" v-if="!loading">
              <div class="card-header py-3">
                <button type="button" class="btn btn-primary" v-on:click="Post" v-if="!is_edit ">新增</button>
                <button type="button" class="btn btn-primary" v-on:click="Update" v-if="is_edit ">儲存</button>
                <button type="button" class="btn btn-danger" v-on:click="Delete" data-bs-toggle="tooltip" data-bs-placement="top" v-if="is_edit">刪除</button>
              </div>
              <div class="card-body">
                <form>
                    <div class="form-group" >
                        <label for="section"><span>*</span>單元</label>
                        <select class="custom-select" v-model="item.selected" @change="SwitchList" > 
                            <option v-for="(item) in datas" :key="item.id" :value="item.id">{{item.data.name}}</option>
                        </select>
                    </div>
                    <div class="form-group">
                         <label for="section"><span>*</span>類別</label>
                        <select class="custom-select" v-model="item.list_selected" > 
                            <option v-for="(item) in list" :key="item.id" :value="item.id">{{item.name}}</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label for="title"><span>*</span>標題</label>
                        <input type="text" class="form-control form-control-user" id="title"  v-model="item.title">
                        <p class="remind title-p" style="font-size: 14px;">
                            <span class="remind" v-if="error.title_p">請填寫標題</span>
                            <span class="remind" v-if="error.title_e">標題不可超過1000個字</span>
                        </p>

                    </div>
                    <div class="form-group">
                        <label for="date"><span>*</span>日期</label>
                        <input type="date" class="form-control form-control-user" id="date"  v-model="item.date" >
                        <p class="remind date-p" style="font-size: 0px;">請填寫日期</p>
                    </div>
                    <UploadFile :name="name" :id="id" :title="title" :src="item.src" :height="item.height" :width="item.width" @update="selfUpdate"></UploadFile>
                    <p class="remind main-photo-p" style="font-size: 0px;">請上傳列表圖</p>
                    <div class="form-group">
                        <label><span>*</span>內容</label>
                        <div class="custom-control custom-radio">
                            <input type="radio" id="link" name="content" class="custom-control-input"  value="true" v-model="is_link" :checked="is_link == 'true'" >
                            <label class="custom-control-label" for="link" >連結</label>
                            <input type="text" class="form-control form-control-user" id="link"  v-model="item.link" :disabled="is_link==='false'" >
                            <p class="remind link-p" style="font-size: 0px;">請填寫連結</p>
                        </div>
                        <div class="custom-control custom-radio">
                            <input type="radio" id="desc" name="content" class="custom-control-input"  value="false"  v-model="is_link"  :checked="is_link == 'false'" >
                            <label class="custom-control-label" for="desc">詳細頁</label>
                            <p class="remind desc-p" style="font-size: 0px;">請填寫詳細內容</p>
                            <ckeditor v-model="item.desc" :config="editorConfig" ></ckeditor>
                        </div>
                    </div>
                </form>
              </div>
            </div>

          </div>
          <!-- /.container-fluid -->

        </div>
        <!-- End of Main Content -->

        <Footer></Footer>

      </div>
      <!-- End of Content Wrapper -->
    </div>
</template>

<script>
import {fb, db } from '../firebase'
import Draggable from 'vuedraggable'
export default {
  name: 'NewsInfo',
  data () {
    return {
        id:this.$route.params.id || db.collection("news").doc().id,
        mode:'',
        is_edit:false,
        name:'news',
        title:'列表圖',
        datas:[],
        list:[],
        tmp:{
          selected:'',
          list_selected:'',
          order:0
        },
        item:{
            selected:'',
            list_selected:'',
            title:'',
            date:'',
            pic_name:'',
            src:'',
            height:'',
            width:'',
            desc:'',
            link:'',
            is_link:false,
            order:0
        },
        is_upload:true,
        uploadValue:100,
        is_link:'true',
        message:'',
        is_error:false,
        loading:true,
        error:{
            title_p:false,
            title_e:false
        },
        editorConfig: {
            // The configuration of the editor.
            filebrowserBrowseUrl: '/admin/image',
            extraPlugins : 'button,panelbutton,colorbutton'
        }
    }
  },
  components: {
    Draggable
  },
  mounted () {
    this.Switch();
    this.GetCatgory();
  },
  watch:{
    is_link:function(){
      $(".link-p").css("font-size","0px");
      $(".desc-p").css("font-size","0px");
    }
  },
  methods: {
    Switch() {
      if ( this.$route.name == 'NewsAdd'  ) {
        this.mode = '新增';
      } else {
        this.mode = '編輯';
        this.is_edit = true;
      }
    },
    SwitchList() {
      // 取出類別
      this.list = this.datas.find(x => x.id === this.item.selected).data.list;
      if ( this.list.length != 0 ) {
        this.item.list_selected = this.list[0].id;
      } else this.item.list_selected = -1;
      this.GetOrder();
    },
    GetCatgory() {
      this.loading = true;
      //  取得單元列表
      db.collection("category").get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
              // doc.data() is never undefined for query doc snapshots
              var data = {"id": doc.id, "data": doc.data()};
              
              this.datas.push(data);
          });
          this.datas.sort( (d1, d2) => d1.data.order - d2.data.order);

          //   編輯
          if ( this.$route.name != 'NewsAdd'  ) {
            this.Get();
          } else {
            //  新增
            this.item.selected = this.datas[0].id;
            this.SwitchList();
            this.loading = false;
          }
      });
    },
    Get(){
        //  取得單元內容 依照ID取得 
        var vm = this;
        db.collection("news").doc(this.id).get().then((doc) => {
          if (doc.exists) {
            this.item = doc.data();
            if (this.item.is_link ) vm.is_link = 'true';
            else vm.is_link = 'false';
            
            // 暫存
            vm.tmp.selected = this.item.selected;
            vm.tmp.list_selected = this.item.list_selected;
            vm.tmp.order = this.item.order;

            this.list = this.datas.find(x => x.id === this.item.selected).data.list;
            this.loading = false;
          } else {
            this.$router.push({name: 'News'}); 
          }
        }).catch((error) => {
            console.log("Error getting document:", error);
        }); 
    },
    GetOrder(){
        var vm = this;
        var array = [];
        //  依照類別名稱取得排序資料
        //  取得該類別最後一個排序號碼
        db.collection("news").where("selected", "==", this.item.selected).get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                // doc.data() is never undefined for query doc snapshots
                var item = doc.data();
                var data = {"id": doc.id, "data": item};

                array.push(data);
            });
            array.sort( (d1, d2) => d2.data.order - d1.data.order);
            if ( array.length > 0 ) this.item.order = array[0].data.order +1;

        });
       
    },
    Auth() {

      var check = true;
      var vm = this;
      
      if ( this.item.title.length == 0) {
        $(".title-p").css("font-size","14px");
        this.error.title_p = true;
        check = false;
      } else {
        this.error.title_p = false;
        if ( this.item.title.length > 1000) {
          $(".title-p").css("font-size","14px");
          this.error.title_e = true;
          check = false;
        } else {
          $(".title-p").css("font-size","0px");
          this.error.title_e = false;
        }
      }

      if ( this.item.date.length == 0 ) {
        $(".date-p").css("font-size","14px");
        check = false;
      } else $(".date-p").css("font-size","0px");
  
      if ( this.item.src.length == 0 ) {
        $(".main-photo-p").css("font-size","14px");
        check = false;
      } else $(".main-photo-p").css("font-size","0px");
      
      if ( this.is_link == 'true') {
        this.item.is_link = true;
        if( this.item.link.length == 0 ) {
           $(".link-p").css("font-size","14px");
          check = false;
        } else  $(".link-p").css("font-size","0px");
        
      } else if ( this.is_link == 'false' ) {
        this.item.is_link = false;
        if( this.item.desc.length == 0 ) {
           $(".desc-p").css("font-size","14px");
          check = false;
        } else  $(".desc-p").css("font-size","0px");
      } 

      if ( this.item.list_selected == -1 ) {
        var name = this.datas.find(x=>x.id == vm.item.selected).data.name;
        check = false;
        alert('單元:' + name + '尚未增加類別，無法進行儲存，請至類別管理新增資料。')
      }

      if (check) return true;
      else return false;
    },
    Post() {
      var vm = this;
      if (this.Auth() ) {
        this.Beforesend();
        db.collection("news").doc(this.id).set(this.item)
        .then((doc) => {
          alert("成功!");
          this.Aftersend()
          this.$router.push({name: 'News'}); 
        }).catch((error) => {
          vm.is_error = true;
          if ( error.indexOf('1048487') > -1) vm.message = '內文超出限制，請縮減內容或降低圖片大小';
          else vm.message = '發生錯誤聯絡管理員';
          console.log("Error getting document:", error);
        });
      }
    },
    Update() {
      var vm = this;
      if (this.Auth() ) {
        this.Beforesend();

        //  如果單元沒有變更，排序要用原本的資料
        if (vm.tmp.selected == vm.item.selected ) vm.item.order = vm.tmp.order;
        
        db.collection("news").doc(this.id).update(this.item)
          .then(() => {
            alert("成功!");
            this.Aftersend();
            this.$router.push({name: 'News'}); 
          }).catch((error) => {
            vm.is_error = true;
            if ( error.indexOf('1048487') > -1) vm.message = '內文超出限制，請縮減內容或降低圖片大小';
            else vm.message = '發生錯誤聯絡管理員';
            console.log("Error getting document:", error);
          });
      }
    },
    Delete() {
      if ( confirm("確定要刪除?") ) {
        db.collection("news").doc(this.id).delete()
        .then(() => {
            alert("刪除成功!");
            this.$router.push({name: 'News'}); 
        }).catch((error) => {
            console.log("Error getting document:", error);
        });
      }
    },
    selfUpdate(val) {
      this.item.src = val.src;
      this.item.width = val.width;
      this.item.height = val.height;
      this.item.pic_name = val.pic_name;
    }
  }
}
</script>
<style scoped>
label{
  cursor: pointer;
}
label span, .remind{
  color:#BE0000
}
</style>


// WEBPACK FOOTER //
// src/components/NewsInfo.vue